import {
  Autocomplete, Box, Button, Checkbox, FormControlLabel, Grid, IconButton,
  TextField, Tooltip, Typography, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { COMMON_STYLE } from '../../../../Utility/Constants';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { AddCircle } from '@material-ui/icons';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const otherInvestState = {
  patientId: '',
  appointmentId: '',
  doctorId: '',
  clinicId: '',
  le_wfdt: '',
  le_eom: '',
  le_colour_vision: '',
  le_confrontation: '',
  le_pupil: '',
  le_pachymentry: '',
  le_schirmers_test: '',
  le_contrast_sensitivity: '',
  le_anterior_image_key: '',
  le_image_json: '',
  le_syringe: '',
  le_additional_details: '',
  le_duct: '',
  re_wfdt: '',
  re_eom: '',
  re_colour_vision: '',
  re_confrontation: '',
  re_pupil: '',
  re_pachymentry: '',
  re_schirmers_test: '',
  re_contrast_sensitivity: '',
  re_syringe: '',
  re_additional_details: '',
  re_duct: '',
  le_wfdt_sugg: [],
  le_eom_sugg: [],
  le_colour_vision_sugg: [],
  le_confrontation_sugg: [],
  le_pupil_sugg: [],
  le_pachymentry_sugg: [],
  le_schirmers_test_sugg: [],
  le_contrast_sensitivity_sugg: [],
  le_anterior_image_key_sugg: [],
  le_image_json_sugg: [],
  le_syringe_sugg: [],
  le_additional_details_sugg: [],
  le_duct_sugg: [],
  re_wfdt_sugg: [],
  re_eom_sugg: [],
  re_colour_vision_sugg: [],
  re_confrontation_sugg: [],
  re_pupil_sugg: [],
  re_pachymentry_sugg: [],
  re_schirmers_test_sugg: [],
  re_contrast_sensitivity_sugg: [],
  re_syringe_sugg: [],
  re_additional_details_sugg: [],
  re_duct_sugg: [],
  custom_column: [],

  prev_le_wfdt: '',
  prev_le_eom: '',
  prev_le_colour_vision: '',
  prev_le_confrontation: '',
  prev_le_pupil: '',
  prev_le_pachymentry: '',
  prev_le_schirmers_test: '',
  prev_le_contrast_sensitivity: '',
  prev_le_anterior_image_key: '',
  prev_le_image_json: '',
  prev_le_syringe: '',
  prev_le_additional_details: '',
  prev_le_duct: '',
  prev_re_wfdt: '',
  prev_re_eom: '',
  prev_re_colour_vision: '',
  prev_re_confrontation: '',
  prev_re_pupil: '',
  prev_re_pachymentry: '',
  prev_re_schirmers_test: '',
  prev_re_contrast_sensitivity: '',
  prev_re_syringe: '',
  prev_re_additional_details: '',
  prev_re_duct: '',
  prev_custom_column: [],

  left_eye_check: false,
  right_eye_check: false,
  normal_check: false,
  otherInvesList: {},
  enableCopy: false,
  dup_custom_data: '',
  left_eye_data: '',
  right_eye_data: ''
}


const UmaOtherInvestigation = React.forwardRef((props, ref) => {
  const [otherInves, setOtherInves] = useState(otherInvestState)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  React.useImperativeHandle(ref, () => ({
    performOtherInvestigationAction: () => {
      let leftEye = otherInves.left_eye_data === '' ? '' : JSON.parse(otherInves.left_eye_data)
      let rightEye = otherInves.right_eye_data === '' ? '' : JSON.parse(otherInves.right_eye_data)
      const leftEyeKeys = ["colour_vision", "confrontation", "contrast_sensitivity", "duct", "eom", "pachymentry", "pupil", "schirmers_test", "syringe", "wfdt", 'additional_details'];
      const rightEyeKeys = ["colour_vision", "confrontation", "contrast_sensitivity", "duct", "eom", "pachymentry", "pupil", "schirmers_test", "syringe", 'wfdt', 'additional_details']
      const hasChanges = leftEyeKeys.some(key => leftEye[key] !== otherInves[`le_${key}`]) ||
        rightEyeKeys.some(key => rightEye[key] !== otherInves[`re_${key}`]) || JSON.stringify(otherInves.custom_column) !== otherInves.dup_custom_data

      if (hasChanges) {
        postOtherInvestigationData()
      }
    }
  }))

  useEffect(() => {
    const eyeKeys = ["colour_vision", "confrontation", "contrast_sensitivity", "duct", "eom", "pachymentry", "pupil", "schirmers_test", "syringe", "wfdt", 'additional_details'];

    const hasChanges =
      eyeKeys.some(key => String(otherInves?.[`le_${key}`] || '').trim() !== '') ||
      eyeKeys.some(key => String(otherInves?.[`re_${key}`] || '').trim() !== '')

    props.setAccordionOpen(hasChanges);
  }, [otherInves]);

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - OTHER INVESTIGATION`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - OTHER INVESTIGATION`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const apicalls = async () => {
    await getOtherInvestData()
    await getOtherInvestigationSuggData()
    await getPrevOtherInvestigationData()
  }

  useEffect(() => {
    if (otherInves.otherInvesList) {
      let copy = Object.keys(otherInves.otherInvesList)?.length > 0 ? true : false
      setOtherInves((prev) => ({
        ...prev,
        enableCopy: copy
      }))
    }
  }, [otherInves.otherInvesList])

  const getOtherInvestData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OTHER_INVESTIGATION + '?appointment_id=' + props?.props?.appointment_id +
        '&doctor_id=' + (props.props?.doctorID || props.props.patient_details?.doctor_id)
      )
      if (response?.data?.status === 'success') {
        let otData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setOtherInves((prev) => ({
          ...prev,
          le_wfdt: Object.keys(otData)?.length > 0 ? otData?.left_eye?.wfdt : '',
          le_eom: Object.keys(otData)?.length > 0 ? otData?.left_eye?.eom : '',
          le_colour_vision: Object.keys(otData)?.length > 0 ? otData?.left_eye?.colour_vision : '',
          le_confrontation: Object.keys(otData)?.length > 0 ? otData?.left_eye?.confrontation : '',
          le_pupil: Object.keys(otData)?.length > 0 ? otData?.left_eye?.pupil : '',
          le_pachymentry: Object.keys(otData)?.length > 0 ? otData?.left_eye?.pachymentry : '',
          le_schirmers_test: Object.keys(otData)?.length > 0 ? otData?.left_eye?.schirmers_test : '',
          le_contrast_sensitivity: Object.keys(otData)?.length > 0 ? otData?.left_eye?.contrast_sensitivity : '',
          le_syringe: Object.keys(otData)?.length > 0 ? otData?.left_eye?.syringe : '',
          le_additional_details: Object.keys(otData)?.length > 0 ? otData?.left_eye?.additional_details : '',
          le_duct: Object.keys(otData)?.length > 0 ? otData?.left_eye?.duct : '',
          left_eye_data: Object.keys(otData)?.length > 0 ? JSON.stringify(otData?.left_eye) : '',

          re_wfdt: Object.keys(otData)?.length > 0 ? otData?.right_eye?.wfdt : '',
          re_eom: Object.keys(otData)?.length > 0 ? otData?.right_eye?.eom : '',
          re_colour_vision: Object.keys(otData)?.length > 0 ? otData?.right_eye?.colour_vision : '',
          re_confrontation: Object.keys(otData)?.length > 0 ? otData?.right_eye?.confrontation : '',
          re_pupil: Object.keys(otData)?.length > 0 ? otData?.right_eye?.pupil : '',
          re_pachymentry: Object.keys(otData)?.length > 0 ? otData?.right_eye?.pachymentry : '',
          re_schirmers_test: Object.keys(otData)?.length > 0 ? otData?.right_eye?.schirmers_test : '',
          re_contrast_sensitivity: Object.keys(otData)?.length > 0 ? otData?.right_eye?.contrast_sensitivity : '',
          re_syringe: Object.keys(otData)?.length > 0 ? otData?.right_eye?.syringe : '',
          re_additional_details: Object.keys(otData)?.length > 0 ? otData?.right_eye?.additional_details : '',
          re_duct: Object.keys(otData)?.length > 0 ? otData?.right_eye?.duct : '',
          right_eye_data: Object.keys(otData)?.length > 0 ? JSON.stringify(otData?.right_eye) : '',

          custom_column: Object.keys(otData)?.length > 0 ? otData?.custom_column : [],
          dup_custom_data: Object.keys(otData)?.length > 0 ? JSON.stringify(otData?.custom_column) : '[]'
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const getPrevOtherInvestigationData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OTHER_INVESTIGATION_COPY +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id +
        '&doctor_id=' + (props.props?.doctorID || props.props.patient_details?.doctor_id))

      if (response?.data?.status === 'success') {
        let otData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}

        setOtherInves((prev) => ({
          ...prev,
          prev_le_wfdt: Object.keys(otData)?.length > 0 ? otData?.left_eye?.wfdt : '',
          prev_le_eom: Object.keys(otData)?.length > 0 ? otData?.left_eye?.eom : '',
          prev_le_colour_vision: Object.keys(otData)?.length > 0 ? otData?.left_eye?.colour_vision : '',
          prev_le_confrontation: Object.keys(otData)?.length > 0 ? otData?.left_eye?.confrontation : '',
          prev_le_pupil: Object.keys(otData)?.length > 0 ? otData?.left_eye?.pupil : '',
          prev_le_pachymentry: Object.keys(otData)?.length > 0 ? otData?.left_eye?.pachymentry : '',
          prev_le_schirmers_test: Object.keys(otData)?.length > 0 ? otData?.left_eye?.schirmers_test : '',
          prev_le_contrast_sensitivity: Object.keys(otData)?.length > 0 ? otData?.left_eye?.contrast_sensitivity : '',
          prev_le_syringe: Object.keys(otData)?.length > 0 ? otData?.left_eye?.syringe : '',
          prev_le_additional_details: Object.keys(otData)?.length > 0 ? otData?.left_eye?.additional_details : '',
          prev_le_duct: Object.keys(otData)?.length > 0 ? otData?.left_eye?.duct : '',

          prev_re_wfdt: Object.keys(otData)?.length > 0 ? otData?.right_eye?.wfdt : '',
          prev_re_eom: Object.keys(otData)?.length > 0 ? otData?.right_eye?.eom : '',
          prev_re_colour_vision: Object.keys(otData)?.length > 0 ? otData?.right_eye?.colour_vision : '',
          prev_re_confrontation: Object.keys(otData)?.length > 0 ? otData?.right_eye?.confrontation : '',
          prev_re_pupil: Object.keys(otData)?.length > 0 ? otData?.right_eye?.pupil : '',
          prev_re_pachymentry: Object.keys(otData)?.length > 0 ? otData?.right_eye?.pachymentry : '',
          prev_re_schirmers_test: Object.keys(otData)?.length > 0 ? otData?.right_eye?.schirmers_test : '',
          prev_re_contrast_sensitivity: Object.keys(otData)?.length > 0 ? otData?.right_eye?.contrast_sensitivity : '',
          prev_re_syringe: Object.keys(otData)?.length > 0 ? otData?.right_eye?.syringe : '',
          prev_re_additional_details: Object.keys(otData)?.length > 0 ? otData?.right_eye?.additional_details : '',
          prev_re_duct: Object.keys(otData)?.length > 0 ? otData?.right_eye?.duct : '',

          prev_custom_column: Object.keys(otData)?.length > 0 ? otData?.custom_column : [],
          otherInvesList: Object.keys(otData)?.length > 0 ? otData : {}
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const groupAndSeparateData = (data) => {
    return data.reduce((result, current) => {
      const unwantedFields = ["eye_type"];
      Object.keys(current).forEach(key => {
        if (unwantedFields.includes(key)) return;
        if (!result[current.eye_type]) {
          result[current.eye_type] = {};
        }
        if (!result[current.eye_type][key]) {
          result[current.eye_type][key] = [];
        }
        if (!result[current.eye_type][key].includes(current[key])) {
          result[current.eye_type][key].push(current[key]);
        }
      });
      return result;
    }, { LE: {}, RE: {} })
  };

  const getOtherInvestigationSuggData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_OTHER_INVESTIGATION_SUGG + '?doctor_id=' + (props.props?.doctorID || props.props.patient_details?.doctor_id))
      if (response?.data?.status === 'success') {
        let otherInvesData = response?.data?.data || []
        const uniqueAttributes = groupAndSeparateData(otherInvesData)
        setOtherInves((prev) => ({
          ...prev,
          le_wfdt_sugg: uniqueAttributes?.LE?.wfdt || [],
          le_eom_sugg: uniqueAttributes?.LE?.eom || [],
          le_colour_vision_sugg: uniqueAttributes?.LE?.colour_vision || [],
          le_confrontation_sugg: uniqueAttributes?.LE?.confrontation || [],
          le_pupil_sugg: uniqueAttributes?.LE?.pupil || [],
          le_pachymentry_sugg: uniqueAttributes?.LE?.pachymentry || [],
          le_schirmers_test_sugg: uniqueAttributes?.LE?.schirmers_test || [],
          le_contrast_sensitivity_sugg: uniqueAttributes?.LE?.contrast_sensitivity || [],
          le_syringe_sugg: uniqueAttributes?.LE?.syringe || [],
          le_additional_details_sugg: uniqueAttributes?.LE?.additional_details || [],
          le_duct_sugg: uniqueAttributes?.LE?.duct || [],

          re_wfdt_sugg: uniqueAttributes?.RE?.wfdt || [],
          re_eom_sugg: uniqueAttributes?.RE?.eom || [],
          re_colour_vision_sugg: uniqueAttributes?.RE?.colour_vision || [],
          re_confrontation_sugg: uniqueAttributes?.RE?.confrontation || [],
          re_pupil_sugg: uniqueAttributes?.RE?.pupil || [],
          re_pachymentry_sugg: uniqueAttributes?.RE?.pachymentry || [],
          re_schirmers_test_sugg: uniqueAttributes?.RE?.schirmers_test || [],
          re_contrast_sensitivity_sugg: uniqueAttributes?.RE?.contrast_sensitivity || [],
          re_syringe_sugg: uniqueAttributes?.RE?.syringe || [],
          re_additional_details_sugg: uniqueAttributes?.RE?.additional_details || [],
          re_duct_sugg: uniqueAttributes?.RE?.duct || [],
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const postOtherInvestigationData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        right_eye: {
          eye_type: 'RE',
          wfdt: otherInves.re_wfdt,
          eom: otherInves.re_eom,
          colour_vision: otherInves.re_colour_vision,
          confrontation: otherInves.re_confrontation,
          pupil: otherInves.re_pupil,
          pachymentry: otherInves.re_pachymentry,
          schirmers_test: otherInves.re_schirmers_test,
          contrast_sensitivity: otherInves.re_contrast_sensitivity,
          syringe: otherInves.re_syringe,
          additional_details: otherInves.re_additional_details,
          duct: otherInves.re_duct,
        },
        left_eye: {
          eye_type: 'LE',
          wfdt: otherInves.le_wfdt,
          eom: otherInves.le_eom,
          colour_vision: otherInves.le_colour_vision,
          confrontation: otherInves.le_confrontation,
          pupil: otherInves.le_pupil,
          pachymentry: otherInves.le_pachymentry,
          schirmers_test: otherInves.le_schirmers_test,
          contrast_sensitivity: otherInves.le_contrast_sensitivity,
          syringe: otherInves.le_syringe,
          additional_details: otherInves.le_additional_details,
          duct: otherInves.le_duct,
        },
        custom_column: otherInves.custom_column
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_OTHER_INVESTIGATION)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getOtherInvestData()
        await getOtherInvestigationSuggData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const autocompleteTextbox = (names, values, label = '', options = []) => {
    try {
      return (
        <Autocomplete
          freeSolo
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          clearIcon
          size='small'
          sx={{ width: '13.5dvw' }}
          value={values}
          options={options}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
          onChange={(e, newValue) => {
            setOtherInves((prev) => ({ ...prev, [names]: newValue }))
          }}
          onInputChange={(e, newValue) => {
            setOtherInves((prev) => ({ ...prev, [names]: newValue }))
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={'Type Remarks'}
              InputProps={{
                ...params.InputProps, emed_tid: names,
                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
              }}
            />
          )}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const textBox = (names, values, placeholders, index, showDelete) => {
    try {
      return (
        <Box component={'div'} display={'flex'} alignItems={'center'}>
          <TextField
            disabled={props?.props?.patient_transfered || props?.props?.isLocked}
            autoComplete='off'
            size='small'
            sx={{ width: '13.5dvw' }}
            value={values}
            onChange={(e) => {
              let value = e.target.value
              setOtherInves((prev) => {
                let customData = [...otherInves.custom_column]
                customData[index] = { ...customData[index], [names]: value }
                return { ...prev, custom_column: customData }
              })
            }}
            placeholder={placeholders}
            InputProps={{ style: { height: COMMON_STYLE.HEIGHT }, emed_tid: names }}
          />
          {showDelete ?
            <IconButton emed_tid='cum_dlt'
              disabled={props?.props?.patient_transfered || props?.props?.isLocked}
              onClick={(e) => {
                let customData = [...otherInves.custom_column]
                customData?.splice(index, 1)
                setOtherInves((prev) => ({ ...prev, custom_column: customData }))
              }}
            ><DeleteIcon color='error' /></IconButton> : null}
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onChangeCheckBox = (e, key) => {
    try {
      let checked = e.target.checked
      const updateEyeState = (eye) => ({
        [`${eye}_wfdt`]: checked ? "Normal" : '',
        [`${eye}_eom`]: checked ? "Normal" : '',
        [`${eye}_colour_vision`]: checked ? "Normal" : '',
        [`${eye}_confrontation`]: checked ? "Normal" : '',
        [`${eye}_pupil`]: checked ? "Normal" : '',
        [`${eye}_pachymentry`]: checked ? "Normal" : '',
        [`${eye}_schirmers_test`]: checked ? "Normal" : '',
        [`${eye}_contrast_sensitivity`]: checked ? "Normal" : '',
        [`${eye}_syringe`]: checked ? "Normal" : '',
        [`${eye}_additional_details`]: checked ? "Normal" : '',
        [`${eye}_duct`]: checked ? "Normal" : '',
      });
      setOtherInves((prev) => {
        switch (key) {
          case 'right_eye_check':
            return {
              ...prev,
              right_eye_check: checked,
              normal_check: prev.left_eye_check && checked,
              ...updateEyeState('re')
            };
          case 'left_eye_check':
            return {
              ...prev,
              left_eye_check: checked,
              normal_check: prev.right_eye_check && checked,
              ...updateEyeState('le')
            };
          case 'normal_check':
            return {
              ...prev,
              normal_check: checked,
              left_eye_check: checked,
              right_eye_check: checked,
              ...updateEyeState('le'),
              ...updateEyeState('re')
            };
          default:
            return prev;
        }
      });
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const onClickCopyHandler = () => {
    try {
      setOtherInves((prev) => ({
        ...prev,
        le_wfdt: otherInves.prev_le_wfdt,
        le_eom: otherInves.prev_le_eom,
        le_colour_vision: otherInves.prev_le_colour_vision,
        le_confrontation: otherInves.prev_le_confrontation,
        le_pupil: otherInves.prev_le_pupil,
        le_pachymentry: otherInves.prev_le_pachymentry,
        le_schirmers_test: otherInves.prev_le_schirmers_test,
        le_contrast_sensitivity: otherInves.prev_le_contrast_sensitivity,
        le_syringe: otherInves.prev_le_syringe,
        le_additional_details: otherInves.prev_le_additional_details,
        le_duct: otherInves.prev_le_duct,
        re_wfdt: otherInves.prev_re_wfdt,
        re_eom: otherInves.prev_re_eom,
        re_colour_vision: otherInves.prev_re_colour_vision,
        re_confrontation: otherInves.prev_re_confrontation,
        re_pupil: otherInves.prev_re_pupil,
        re_pachymentry: otherInves.prev_re_pachymentry,
        re_schirmers_test: otherInves.prev_re_schirmers_test,
        re_contrast_sensitivity: otherInves.prev_re_contrast_sensitivity,
        re_syringe: otherInves.prev_re_syringe,
        re_additional_details: otherInves.prev_re_additional_details,
        re_duct: otherInves.prev_re_duct,
        custom_column: otherInves.prev_custom_column
      }))
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'} width={"100%"}>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Typography className='doc_notes_header_card_font'>Other Investigation</Typography>
              <Tooltip placement='top' arrow title={'Copy'}><IconButton className='Common_Btn_Min_Width' emed_tid='cpy'
                disabled={!otherInves.enableCopy || props?.props.patient_transfered || props?.props?.isLocked}
                onClick={() => onClickCopyHandler()}><ContentCopyIcon color={!otherInves.enableCopy ? '' : 'primary'} /></IconButton></Tooltip>
            </Box>
            <Box component={'div'}>
              <FormControlLabel control={<Checkbox size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={otherInves.right_eye_check} onChange={(e) => onChangeCheckBox(e, 'right_eye_check')} />} label="Right Eye" />
              <FormControlLabel control={<Checkbox size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={otherInves.left_eye_check} onChange={(e) => onChangeCheckBox(e, 'left_eye_check')} />} label="Left Eye" />
              <FormControlLabel control={<Checkbox size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} checked={otherInves.normal_check} onChange={(e) => onChangeCheckBox(e, 'normal_check')} />} label="Normal" />
            </Box>
          </Box>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <Box component={'div'}>
              <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'></Typography></Grid>
                <Grid xs={4.5}><Typography className='doc_notes_header_card_font'>Right Eye</Typography></Grid>
                <Grid xs={4.5}><Typography className='doc_notes_header_card_font'>Left Eye</Typography></Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>WFDT</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_wfdt', otherInves.re_wfdt, 'label', otherInves.re_wfdt_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_wfdt', otherInves.le_wfdt, 'label', otherInves.le_wfdt_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>EOM</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_eom', otherInves.re_eom, 'label', otherInves.re_eom_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_eom', otherInves.le_eom, 'label', otherInves.le_eom_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Colour Vision</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_colour_vision', otherInves.re_colour_vision, 'label', otherInves.re_colour_vision_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_colour_vision', otherInves.le_colour_vision, 'label', otherInves.le_colour_vision_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Confrontation</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_confrontation', otherInves.re_confrontation, 'label', otherInves.re_confrontation_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_confrontation', otherInves.le_confrontation, 'label', otherInves.le_confrontation_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Pupil</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_pupil', otherInves.re_pupil, 'label', otherInves.re_pupil_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_pupil', otherInves.le_pupil, 'label', otherInves.le_pupil_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Pachymetry</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_pachymentry', otherInves.re_pachymentry, 'label', otherInves.re_pachymentry_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_pachymentry', otherInves.le_pachymentry, 'label', otherInves.le_pachymentry_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Schirmer's Test</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_schirmers_test', otherInves.re_schirmers_test, 'label', otherInves.re_schirmers_test_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_schirmers_test', otherInves.le_schirmers_test, 'label', otherInves.le_schirmers_test_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Contrast Sensitivity</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_contrast_sensitivity', otherInves.re_contrast_sensitivity, 'label', otherInves.re_contrast_sensitivity_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_contrast_sensitivity', otherInves.le_contrast_sensitivity, 'label', otherInves.le_contrast_sensitivity_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Syringe</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_syringe', otherInves.re_syringe, 'label', otherInves.re_syringe_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_syringe', otherInves.le_syringe, 'label', otherInves.le_syringe_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Additional Details</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_additional_details', otherInves.re_additional_details, 'label', otherInves.re_additional_details_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_additional_details', otherInves.le_additional_details, 'label', otherInves.le_additional_details_sugg)} </Grid>
              </Grid>
              <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                <Grid xs={3}><Typography className='doc_notes_header_card_font'>Duct</Typography></Grid>
                <Grid xs={4.5}>{autocompleteTextbox('re_duct', otherInves.re_duct, 'label', otherInves.re_duct_sugg)}</Grid>
                <Grid xs={4.5}>{autocompleteTextbox('le_duct', otherInves.le_duct, 'label', otherInves.le_duct_sugg)} </Grid>
              </Grid>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              {otherInves.custom_column?.length > 0 ? otherInves?.custom_column?.map((item, index) => {
                return (
                  <Box component={'div'} key={index}>
                    <Grid container sx={{ display: 'flex', alignItems: 'center', mt: '0.8rem' }}>
                      <Grid xs={3}>{textBox('label', item?.label, 'Label', index)}</Grid>
                      <Grid xs={4.5}>{textBox('re_eye', item?.re_eye, 'Type Remarks', index)}</Grid>
                      <Grid xs={4.5}>{textBox('le_eye', item?.le_eye, 'Type Remarks', index, true)}</Grid>
                    </Grid>
                  </Box>
                )
              }) : null}
              <Box>
                <Button variant='contained' startIcon={<AddCircle />} emed_tid='add_cums'
                  sx={{ textTransform: 'capitalize', height: '4.5dvh', mt: '0.5rem' }}
                  disabled={props?.props?.patient_transfered || props?.props?.isLocked || otherInves?.custom_column.length > 0 && (!otherInves.custom_column[otherInves.custom_column?.length - 1]?.re_eye && !otherInves.custom_column[otherInves.custom_column?.length - 1]?.le_eye)}
                  onClick={() => {
                    let obj = { label: '', re_eye: '', le_eye: '' }
                    otherInves.custom_column?.push(obj)
                    setOtherInves((prev) => ({ ...prev, custom_column: otherInves.custom_column }))
                  }}
                >Add</Button>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaOtherInvestigation